module.exports = __webpack_public_path__ + "static/img/ee229c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/simulate/images/bg.png
// module id = 643
// module chunks = 2